
import React, { useState } from 'react';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { ReactComponent as InfoIcon } from "../../assets/icons/info.svg";
import { ReactComponent as CloseIcon } from "../../assets/cross.svg";

import styles from './InformationalPopover.module.scss';

export const InformationalPopover = ({ triggerText = "See an example of what to write", title = "Example response", description }) => {
    const [show, setShow] = useState(false);
    const toggle = () => setShow(!show);

    return (
        <>
            <button id="Popover1" className={styles.link} onClick={toggle}>
                <InfoIcon />
                <span>{triggerText || 'See an example of what to write'}</span>
            </button>
            <Popover placement="bottom-start" isOpen={show} target="Popover1" toggle={toggle} className={styles.popover}>
                <PopoverHeader className={styles.header}>
                    <span>{title || "Example response"}</span>
                    <button className={styles.close} onClick={toggle}>
                        <CloseIcon /> 
                        <span>Close</span>
                    </button>
                </PopoverHeader>
                <PopoverBody className={styles.body}>
                    {description}
                </PopoverBody>
            </Popover>
        </>
    )
}